import AgencyHelper from 'features/Agency/agencyHelper';
import AgencyContractListView from 'features/Agency/components/AgencyContractListView';
import AgencySaleOrderListView from 'features/Agency/components/AgencySaleOrderListView';
import ChargeHelper from 'features/Charge/chargeHelper';
import DealerHelper from 'features/ManageDealer/dealerHelper';
import AppTabs from 'general/components/AppTabs';
import BreadcrumbHelper from 'general/components/CustomBreadcrumb/BreadcrumbHelper';
import KTLabel, { KTLabelSize } from 'general/components/OtherKeenComponents/KTLabel';
import CustomCard from 'general/components/Others/CustomCard';
import VITableRowDropDown from 'general/components/VITableRowDropDown';
import AppColors from 'general/constants/AppColors';
import AppConstants from 'general/constants/AppConstants';
import AppResource from 'general/constants/AppResource';
import AgencyUIHelper from 'general/helpers/AgencyUIHelper';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import useRouter from 'hooks/useRouter';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

function ChargePointPartnerDetailScreen(props) {
    // ---- params ----
    const { isInvestorInfo = false } = props;
    const { t } = useTranslation();
    const router = useRouter();
    const agencyId = router.query?.agencyId;
    const agencyInfoRef = useRef();
    const { user } = useSelector((state) => state.auth);
    const [agencyDetail, setAgencyDetail] = useState(null);
    const [selectedTab, setSelectedTab] = useState(t('Danh sách hợp đồng'));
    const agencyBank = agencyDetail?.bankAccounts?.length ? agencyDetail?.bankAccounts[0] : {};
    const isAgencyIndividual = useMemo(() => {
        return agencyDetail && agencyDetail?.type === AppConstants.accountType.individual;
    }, [agencyDetail]);

    const adminRole =
        user?.role === AppConstants.userRole.admin || user?.role === AppConstants.userRole.operator;
    const [parentAgencyDetail, setParentAgencyDetail] = useState();
    useEffect(() => {
        if (agencyDetail?.parentAgencyId) {
            AgencyHelper.API.requestAgencyDetail(agencyDetail?.parentAgencyId).then((data) => {
                setParentAgencyDetail(data);
            });
        }
    }, [agencyDetail]);

    const areaTree = useSelector((state) => state.app.areaTree);
    const [agencyArea, setAgencyArea] = useState(null);
    const [agencyParentArea, setAgencyParentArea] = useState(null);
    useEffect(() => {
        if (areaTree && !_.isEmpty(areaTree) && agencyDetail) {
            const agencyAreaId = agencyDetail?.areaId;
            const agencyArea = ChargeHelper.Utils.getAreaById([areaTree], agencyAreaId);
            setAgencyArea(agencyArea);
            setAgencyParentArea(ChargeHelper.Utils.getAreaById([areaTree], agencyArea?.parentId));
        }
    }, [areaTree, agencyDetail]);

    useEffect(() => {
        getAgencyDetail(agencyId);
    }, [agencyId]);

    const getAgencyDetail = (id) => {
        DealerHelper.callApiGetAgencyDetail(id).then((data) => {
            if (Object.keys(data)?.length > 0) {
                setAgencyDetail({ ...agencyDetail, ...data });
            } else {
                router.navigate(-1);
            }
        });
    };

    const hash = router?.location?.hash;

    const tabs = useMemo(() => {
        if (adminRole) {
            return [
                t('Danh sách hợp đồng'),
                t('Lịch sử mua trụ sạc'),
            ].reverse();
        } else {
            return [
                t('Danh sách hợp đồng'),
                t('Lịch sử mua trụ sạc'),
            ].reverse();
        }
    }, [t, adminRole]);

    useEffect(() => {
        if (hash === '#contract-list') setSelectedTab(t('Danh sách hợp đồng'));
        if (hash === '#point-sale') setSelectedTab(t('Lịch sử mua trụ sạc'));
    }, [hash]);

    const contractListView = useMemo(() => {
        return <AgencyContractListView agencyId={agencyId} onRefresh={() => getAgencyDetail(agencyId)} ignoreFilterButton={true} ignoreCreateContractButton={true} />;
    }, [agencyDetail]);

    const saleOrderListView = useMemo(() => {
        return <AgencySaleOrderListView buyerId={agencyId} defaultOrderType="CHARGEPOINT"
            additionalComponent={UIHelper.buildGreenButton(
                'Thêm đơn hàng',
                () => {
                    router.navigate(`add-order?chargepoint=${agencyId}`);
                },
                <i className="fa-regular fa-circle-plus" />
            )}
        />;
    }, [agencyId]);

    const handleSelectedTab = (newTab) => {
        if (selectedTab === newTab) return;
        if (newTab === t('Lịch sử mua trụ sạc')) {
            router.navigate('#point-sale');
        }
        setSelectedTab(newTab);
    };

    const AgencyInfo = () => {
        return (
            <div
                className="col-12 row m-0 px-0"
            >
                <div
                    className="p-3 bg-white rounded-lg"
                    style={{
                        border: `1px solid ${AppColors.gray[300]}`,
                        boxShadow: '0px 7px 8px -3px #0000000D',
                    }}
                >
                    <div className="d-flex px-0 align-items-start">
                        <div className="d-flex align-items-center">
                            <img
                                className="rounded-circle"
                                src={
                                    (() => {
                                        const ownerUser = agencyDetail?.users?.find(
                                            user => user?.email === agencyDetail?.email
                                        );
                                        return ownerUser?.avatar
                                            ? Utils.getFullUrl(ownerUser.avatar)
                                            : AppResource.icons.avatar.default;
                                    })()
                                }
                                style={{
                                    width: 44,
                                }}
                            />
                            <div className="d-flex flex-column ml-3">
                                <div className="d-flex align-items-start gap-2" style={{ overflow: 'hidden' }}>
                                    <span
                                        // className="font-weight-bolder text-ellipsis-2-lines"
                                        style={UIHelper.buildFontStyle('600', '18px', AppColors.gray[800])}
                                    >
                                        {agencyDetail?.name}
                                    </span>

                                    <span className="min-w-100px pt-1">
                                        <KTLabel
                                            text={t(`agencyStatus_${agencyDetail?.status}`)}
                                            isInline={true}
                                            size={KTLabelSize.medium}
                                            additionalClassName={`label-light-${DealerHelper.getAgencyStatusColor(
                                                agencyDetail?.status
                                            )}`}
                                        />
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className="d-flex gap-3 justify-content-end ml-auto">
                            <VITableRowDropDown
                                toggleElement={
                                    <a
                                        href="#"
                                        className="btn btn-sm btn-clean btn-icon h-45px w-45px hover-opacity-60"
                                        style={{ backgroundColor: AppColors.gray[200] }}
                                        onClick={(e) => {
                                            e.preventDefault();
                                        }}
                                    >
                                        <i
                                            className="fa-solid fa-ellipsis"
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        />
                                    </a>
                                }
                                menuItem={[
                                    {
                                        iconElement: <i className={`fa-regular fa-bolt`}></i>,
                                        text: t('Kích hoạt tài khoản'),
                                        click: () => {
                                            DealerHelper.handleAcceptAgency(agencyDetail, () => {
                                                getAgencyDetail(agencyId);
                                            });
                                        },
                                        show: agencyDetail?.status === 'REGISTERED'
                                            && (adminRole || DealerHelper.checkHasEditPermission(
                                                agencyDetail,
                                                parentAgencyDetail,
                                                user?.agency
                                            )),
                                    },
                                    {
                                        iconElement: <i className="fa-regular fa-pen-to-square"></i>,
                                        text: t('edit'),
                                        click: () => {
                                            router.navigate('edit');
                                        },
                                        show: !agencyDetail?.numberOfSignedContracts
                                            && DealerHelper.checkHasEditPermission(
                                                agencyDetail,
                                                parentAgencyDetail,
                                                user?.agency
                                            )
                                            || adminRole,
                                    },
                                    {
                                        iconElement: <i className="fa-regular fa-plus-circle"></i>,
                                        text: t('addOrder'),
                                        click: () => {
                                            router.navigate(`add-order?chargepoint=${agencyDetail?.agencyId}`);
                                        },
                                        show:
                                            agencyDetail?.status === 'NORMAL' &&
                                            (adminRole || DealerHelper.checkHasEditPermission(
                                                agencyDetail,
                                                parentAgencyDetail,
                                                user?.agency
                                            ))
                                            && !isInvestorInfo,
                                    },
                                    {
                                        iconElement: <i className="far fa-square"></i>,
                                        text: t('Ngừng hoạt động'),
                                        click: () => {
                                            DealerHelper.handleStopAgency(agencyDetail, () => {
                                                getAgencyDetail(agencyId);
                                            });
                                        },
                                        show:
                                            agencyDetail?.status === 'NORMAL'
                                            && (adminRole || DealerHelper.checkHasEditPermission(
                                                agencyDetail,
                                                parentAgencyDetail,
                                                user?.agency
                                            ))
                                            && !isInvestorInfo,
                                    },
                                    {
                                        iconElement: <i className="far fa-play"></i>,
                                        text: t('Khôi phục hoạt động'),
                                        click: () => {
                                            DealerHelper.handleActiveAgency(agencyDetail, () => {
                                                getAgencyDetail(agencyId);
                                            });
                                        },
                                        show:
                                            agencyDetail?.status === 'SUSPENDED'
                                            && (adminRole || DealerHelper.checkHasEditPermission(
                                                agencyDetail,
                                                parentAgencyDetail,
                                                user?.agency
                                            ))
                                            && !isInvestorInfo,
                                    },
                                    // {
                                    //     iconElement: <i className="fa-regular fa-file-contract"></i>,
                                    //     text: 'Tạo hợp đồng CTV',
                                    //     click: () => {
                                    //         AgencyHelper.UI.showDialogConfirmCreateContractWithAgency(
                                    //             agencyDetail,
                                    //             () => { }
                                    //         );
                                    //     },
                                    //     show:
                                    //         !agencyDetail?.numberOfSignedContracts &&
                                    //         agencyDetail?.status !== 'REGISTERED'
                                    //         && adminRole,
                                    // },
                                    // {
                                    //     iconElement: (
                                    //         <i
                                    //             className={`fa-regular fa-lock`}
                                    //             style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                    //         ></i>
                                    //     ),
                                    //     text: t('Đặt lại mật khẩu'),
                                    //     click: () => {
                                    //         DealerHelper.showDialogChangePassword(agencyDetail, () => {
                                    //             getAgencyDetail(agencyId);
                                    //         });
                                    //     },
                                    //     show: adminRole,
                                    // },
                                    {
                                        iconElement: <i className={`fa-regular fa-trash-can`}></i>,
                                        text: t('Xóa đối tác'),
                                        click: () => {
                                            DealerHelper.handleDeleteAgency(agencyDetail, () => {
                                                router.navigate(-1);
                                            });
                                        },
                                        show: !agencyDetail?.numberOfSignedContracts
                                            && (adminRole || DealerHelper.checkHasEditPermission(
                                                agencyDetail,
                                                parentAgencyDetail,
                                                user?.agency
                                            ))
                                            && !isInvestorInfo,
                                    },
                                ]}
                            />
                        </div>
                    </div>

                    <div
                        className="col-12 my-4 "
                        style={{
                            borderBottom: `1px dashed ${AppColors.gray[300]}`,
                        }}
                    />

                    {/* thong tin Nha dau tu */}
                    <div className="col-xl-12 col-lg-12 col-md-12 d-flex flex-column px-0 ">
                        <div className=" d-flex flex-lg-row flex-column flex-wrap">
                            <div className="col-xl-6 p-0 pr-xl-3 pl-0 d-flex flex-column gap-3">
                                {AgencyUIHelper.buildAccountInfoCard(agencyDetail, parentAgencyDetail, isAgencyIndividual, "CHARGEPOINT")}

                                {AgencyUIHelper.buildDocumentInfoCard(agencyDetail, isAgencyIndividual)}
                            </div>

                            <div className="col-xl-6 p-0 pl-0 d-flex flex-column gap-3 mt-4 mt-lg-0">
                                {AgencyUIHelper.buildOtherInfoCard(agencyDetail, agencyParentArea, agencyArea, agencyBank, isAgencyIndividual, adminRole, isInvestorInfo)}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div>
            <div className="w-100">
                {!isInvestorInfo && BreadcrumbHelper.buildBreadcrumb([
                    {
                        title: `Danh sách đối tác mua trụ sạc`,
                        onPress: () => {
                            router.navigate(-1);
                        },
                    },
                    { title: 'Chi tiết đối tác' },
                ])}
            </div>

            <div className={`m-4 ${!isInvestorInfo ? 'mt-16' : ''}`}>
                {/* thong tin Nha dau tu */}
                <CustomCard
                    showHeader={false}
                    additionalClassName="rounded-lg overflow-hidden"
                    bgTransparent={true}
                    showBorder={false}
                    body={
                        <div className="d-xl-flex d-lg-flex"
                            ref={agencyInfoRef}
                        >
                            {/* thong tin Nha dau tu */}
                            <AgencyInfo />
                        </div>
                    }
                />

                {/* table */}
                <div>
                    <AppTabs
                        tabs={tabs}
                        activeTab={selectedTab}
                        handleClick={handleSelectedTab}
                        className="mt-3 mr-3"
                        additionalClassName=""
                    />
                    <div
                        className="bg-white shadow"
                        style={{
                            borderLeft: `1px solid ${AppColors.gray[300]}`,
                            borderRight: `1px solid ${AppColors.gray[300]}`,
                            borderBottom: `1px solid ${AppColors.gray[300]}`,
                            borderRadius: '0px 10px 10px 10px',
                        }}
                    >
                        <>
                            <div
                                key={selectedTab}
                                initial={{ y: 10, opacity: 0 }}
                                animate={{ y: 0, opacity: 1 }}
                                exit={{ y: -10, opacity: 0 }}
                                transition={{ duration: 0.2 }}
                            >
                                {selectedTab == t('Danh sách hợp đồng') && (
                                    <div className="py-4">{contractListView}</div>
                                )}
                                {selectedTab == t('Lịch sử mua trụ sạc') && (
                                    <div className="px-1 pt-2">{saleOrderListView}</div>
                                )}
                            </div>
                        </>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ChargePointPartnerDetailScreen;
